import { gql } from '@apollo/client';

export const GET_FINTEL_CHECK_RULES = gql`
  query checkRules($input: CheckRuleInput!) {
    checkRules(input: $input) {
      count
    }
  }
`;
